import TheGrid from '@/views/familymembers/grid'
import ThePaginatedGrid from '@/views/familymembers/paginated'
import Edit from '@/views/familymembers/edit'
import TheView from '@/views/familymembers/view'

export default {
  path: '/familymembers',
  redirect: '/familymembers/index',
  name: 'familymembers',
  meta: {
    auth: {
      redirect: {
        name: 'familymembers.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Pessoas'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'familymembers.index',
    component: ThePaginatedGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'paginated',
    name: 'familymembers.paginated',
    component: ThePaginatedGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'familymembers.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'familymembers.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }, {
    path: 'view/:id',
    name: 'familymembers.view',
    component: TheView,
    meta: {
      auth: true,
      label: 'Ver'
    }
  }]
}
